module.exports = __webpack_public_path__ + "img/141.e5f0c6d1.png";